export default {
      id: "partlist-usage",
      viewBox: "0 0 28.24 37.699",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#partlist",
      toString: function () {
        return this.url;
      }
    }